var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect, _path21, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 82,
    viewBox: "0 0 102 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2898 6.49536H77.3688C83.6913 6.49536 88.8166 11.6044 88.8166 17.9068V63.8393C88.8166 70.1417 83.6913 75.2508 77.3688 75.2508H31.2898C24.9673 75.2508 19.842 70.1417 19.842 63.8393V17.9068C19.842 11.6044 24.9673 6.49536 31.2898 6.49536Z",
    fill: "#F3F3F3",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3622 47.4553H77.2416C79.3552 47.4553 81.0686 49.1633 81.0686 51.2702V75.1405C81.0686 77.2474 79.3552 78.9554 77.2416 78.9554H76.3622C74.2486 78.9554 72.5352 77.2474 72.5352 75.1405V51.2702C72.5352 49.1633 74.2486 47.4553 76.3622 47.4553Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3442 50.1125H70.2235C72.3371 50.1125 74.0505 51.8205 74.0505 53.9274V77.7977C74.0505 79.9046 72.3371 81.6126 70.2235 81.6126H69.3442C67.2306 81.6126 65.5172 79.9046 65.5172 77.7977V53.9274C65.5172 51.8205 67.2306 50.1125 69.3442 50.1125Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7048 50.8513H44.4908C43.1358 50.8513 42.0408 51.9484 42.0408 53.2935V70.5705C42.0408 76.1054 46.5481 80.5983 52.1006 80.5983C57.653 80.5983 62.1603 76.1054 62.1603 70.5705V53.2935C62.1603 51.9428 61.0597 50.8513 59.7103 50.8513H59.7048Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0503 58.4092H58.2392C59.1739 58.4092 59.9315 59.1644 59.9315 60.0961V67.3785C59.9315 68.3101 59.1739 69.0654 58.2392 69.0654H46.0503C45.1157 69.0654 44.358 68.3101 44.358 67.3785V60.0961C44.358 59.1644 45.1157 58.4092 46.0503 58.4092Z",
    fill: "#FFE4E4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62793 26.5566H35.056C37.0596 26.5566 38.6839 28.1758 38.6839 30.173V76.9821C38.6839 78.9793 37.0596 80.5984 35.056 80.5984H4.62793C2.62428 80.5984 1 78.9793 1 76.9821V30.173C1 28.1758 2.62428 26.5566 4.62793 26.5566Z",
    fill: "#FFE4E4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.842 50.7191C18.5775 50.7191 17.5524 49.6973 17.5524 48.4368C17.5524 47.1764 18.5775 46.1545 19.842 46.1545C21.1064 46.1545 22.1315 47.1764 22.1315 48.4368C22.1315 49.6973 21.1064 50.7191 19.842 50.7191Z",
    fill: "#DA1F1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87069 50.7191C8.6062 50.7191 7.58112 49.6973 7.58112 48.4368C7.58112 47.1764 8.6062 46.1545 9.87069 46.1545C11.1352 46.1545 12.1603 47.1764 12.1603 48.4368C12.1603 49.6973 11.1352 50.7191 9.87069 50.7191Z",
    fill: "#DA1F1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8132 50.7191C28.5487 50.7191 27.5236 49.6973 27.5236 48.4368C27.5236 47.1764 28.5487 46.1545 29.8132 46.1545C31.0777 46.1545 32.1028 47.1764 32.1028 48.4368C32.1028 49.6973 31.0777 50.7191 29.8132 50.7191Z",
    fill: "#DA1F1F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8419 58.8173C18.5774 58.8173 17.5524 57.7955 17.5524 56.535C17.5524 55.2745 18.5774 54.2527 19.8419 54.2527C21.1064 54.2527 22.1315 55.2745 22.1315 56.535C22.1315 57.7955 21.1064 58.8173 19.8419 58.8173Z",
    fill: "#DA1F1F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87068 58.8173C8.60619 58.8173 7.58111 57.7955 7.58111 56.535C7.58111 55.2745 8.60619 54.2527 9.87068 54.2527C11.1352 54.2527 12.1603 55.2745 12.1603 56.535C12.1603 57.7955 11.1352 58.8173 9.87068 58.8173Z",
    fill: "#DA1F1F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8132 58.8173C28.5487 58.8173 27.5236 57.7955 27.5236 56.535C27.5236 55.2745 28.5487 54.2527 29.8132 54.2527C31.0777 54.2527 32.1028 55.2745 32.1028 56.535C32.1028 57.7955 31.0777 58.8173 29.8132 58.8173Z",
    fill: "#DA1F1F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8419 66.9103C18.5774 66.9103 17.5524 65.8885 17.5524 64.628C17.5524 63.3675 18.5774 62.3457 19.8419 62.3457C21.1064 62.3457 22.1315 63.3675 22.1315 64.628C22.1315 65.8885 21.1064 66.9103 19.8419 66.9103Z",
    fill: "#DA1F1F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87068 66.9103C8.60619 66.9103 7.58111 65.8885 7.58111 64.628C7.58111 63.3675 8.60619 62.3457 9.87068 62.3457C11.1352 62.3457 12.1603 63.3675 12.1603 64.628C12.1603 65.8885 11.1352 66.9103 9.87068 66.9103Z",
    fill: "#DA1F1F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8132 66.9103C28.5487 66.9103 27.5236 65.8885 27.5236 64.628C27.5236 63.3675 28.5487 62.3457 29.8132 62.3457C31.0777 62.3457 32.1028 63.3675 32.1028 64.628C32.1028 65.8885 31.0777 66.9103 29.8132 66.9103Z",
    fill: "#DA1F1F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.842 75.0031C18.5775 75.0031 17.5524 73.9812 17.5524 72.7208C17.5524 71.4603 18.5775 70.4385 19.842 70.4385C21.1064 70.4385 22.1315 71.4603 22.1315 72.7208C22.1315 73.9812 21.1064 75.0031 19.842 75.0031Z",
    fill: "#DA1F1F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50571 32.0308H30.1727C31.2386 32.0308 32.1028 32.8921 32.1028 33.9547V38.9548C32.1028 40.0174 31.2386 40.8788 30.1727 40.8788H9.50571C8.43974 40.8788 7.57562 40.0174 7.57562 38.9548V33.9547C7.57562 32.8921 8.43974 32.0308 9.50571 32.0308Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7155 80.5981C88.1401 80.5981 84.431 75.2077 84.431 68.5582C84.431 61.9088 88.1401 56.5183 92.7155 56.5183C97.2909 56.5183 101 61.9088 101 68.5582C101 75.2077 97.2909 80.5981 92.7155 80.5981Z",
    fill: "#FFE4E4",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7155 64.6274V73.5857",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2193 69.1094H97.2062",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.0311,
    width: 32.1355,
    height: 32.1355,
    rx: 16.0678,
    fill: "#DA1F1F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44_488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 8,
    width: 13,
    height: 17
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7504 18.1277C77.5899 17.8483 77.649 17.522 77.8372 17.3243C77.9406 17.2154 78.1304 17.1036 78.5473 16.729C81.9278 13.6921 80.7083 10.6498 77.1232 9.7209C76.519 9.56435 76.241 9.54608 75.9561 9.474C75.6388 9.39377 75.3752 9.03917 75.4806 8.64451C75.5726 8.29966 75.8937 8.12524 76.1687 8.14225C78.8497 8.30856 84.7142 9.01571 86.9014 12.821C89.0888 16.6263 86.7663 22.0812 85.5693 24.4963C85.4465 24.744 85.1354 24.9361 84.7922 24.8436C84.3992 24.738 84.2252 24.3314 84.3147 24.0152C84.395 23.7314 84.5182 23.4804 84.6854 22.8767C85.6769 19.2937 83.6636 16.7119 79.355 18.1338C78.8235 18.3093 78.632 18.4183 78.4866 18.4539C78.2219 18.5189 77.9111 18.4071 77.7504 18.1277Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44_488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.7504 18.1277C77.5899 17.8483 77.649 17.522 77.8372 17.3243C77.9406 17.2154 78.1304 17.1036 78.5473 16.729C81.9278 13.6921 80.7083 10.6498 77.1232 9.7209C76.519 9.56435 76.241 9.54608 75.9561 9.474C75.6388 9.39377 75.3752 9.03917 75.4806 8.64451C75.5726 8.29966 75.8937 8.12524 76.1687 8.14225C78.8497 8.30856 84.7142 9.01571 86.9014 12.821C89.0888 16.6263 86.7663 22.0812 85.5693 24.4963C85.4465 24.744 85.1354 24.9361 84.7922 24.8436C84.3992 24.738 84.2252 24.3314 84.3147 24.0152C84.395 23.7314 84.5182 23.4804 84.6854 22.8767C85.6769 19.2937 83.6636 16.7119 79.355 18.1338C78.8235 18.3093 78.632 18.4183 78.4866 18.4539C78.2219 18.5189 77.9111 18.4071 77.7504 18.1277Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.e757b811d4a2082ef4927d24dfaaca02.svg";
export { ForwardRef as ReactComponent };